import ImageLogo from '../asserts/logo.png'

import ImageFooterCompany1 from '../asserts/footer/company1.png'
import ImageFooterCompany2 from '../asserts/footer/company2.png'

export const APPCONFIG = {
  name: { en: 'Double-Dove', cn: '双鸽集团' },
  title: { en: 'Jumin Bio-technologies Co.,Ltd', cn: '聚民生物科技有限公司' },
  logo: ImageLogo,
  tab: [
    { en: 'Home', cn: '首页', path: '/' },
    { en: 'About', cn: '关于我们', path: '/about' },
    { en: 'Products', cn: '产品展示', path: '/product' },
    { en: 'News', cn: '新闻资讯', path: '/news' },
    // { en: 'Contact', cn: '联系我们', path: '/' }
  ],
  contact: {
    location: {
      label: { en: 'Address', cn: '地址' },
      value: { en: 'No.1888 Huhang Road,Fengxian District,Shanghai,China', cn: '上海市奉贤区沪杭公路1888号' }
    },
    phone: {
      label: { en: 'Tel', cn: '销售部电话' },
      value: { en: '+86-021-67104888', cn: '021-67104888' }
    },
    email: {
      label: { en: 'Email', cn: '邮箱' },
      value: { en: 'master@juminshengwu.com', cn: 'master@juminshengwu.com' }
    },
    time: {
      value: { en: 'Mon-Fri 8:00-18:00', cn: '周一至周五 8:00-18:00' }
    },
    fax: {
      label: { en: 'Fax', cn: '传真号码' },
      value: { en: '+86-021-67104666', cn: '021-67104666' }
    },
    postal: {
      label: { en: 'Postal NO', cn: '邮政编码' },
      value: { en: '201499', cn: '201499' }
    }
  },
  footer: {
    link: { en: 'Friendship Links', cn: '友情链接' },
    company: [
      {
        name: { en: 'LINEAR', cn: 'LINEAR' },
        logo: ImageFooterCompany1,
        link: 'http://www.linear.es/'
      },
      {
        name: { en: 'CHIMIN', cn: '济民制药' },
        logo: ImageFooterCompany2,
        link: 'http://www.chimin.cn/'
      }
    ],
    copyright: 'Copyright © 2021 Double-Dove Industrial Co.,Ltd All Rights Reserved.'
  }
}